export default __webpack_public_path__ + "static/media/empty_img.d31a7d7e.png";